import React from "react";
import PropTypes from "prop-types";
import Asset from "../../../../requests/apa/Asset";
import "./avatar-images.scss";

const avatars = [
	{ size: '9.6rem', left: 0, top: 0 },
	{ size: '7.6rem', left: '12.4rem', top: '2.93rem' },
	{ size: '5.6rem', left: 0, top: '12.66rem' },
	{ size: '10.4rem', left: '8.53rem', top: '12.93rem' }
];

const AvatarImages = ({ img = []  }) => (
	<div className="avatar-images" aria-label="Avatares">
		{img.slice(0, avatars.length).map((avatar, index) => (
			<img
				key={index}
				className="avatar-images__item"
				src={Asset.get(avatar)}
				style={{ left: avatars[index].left, top: avatars[index].top, borderRadius: avatars[index].size, width: avatars[index].size, height: avatars[index].size }}
			/>
		))}
	</div>
);

AvatarImages.propTypes = {
	img: PropTypes.arrayOf(PropTypes.string)
};

export default AvatarImages;


// WEBPACK FOOTER //
// ./src/containers/config/components/AvatarImages/AvatarImages.jsx